const K = {
    email: {
        serviceID: process.env.REACT_APP_EMAIL_SERVICE_ID,
        publicKey: process.env.REACT_APP_EMAIL_PUBLIC_KEY,
        templateID: process.env.REACT_APP_EMAIL_TEMPLATE_ID
    }
};

export default K;